import React from "react";
import { Link } from "react-router-dom"; 

const PageHeader = ({ title, bgImg, overlay }) => {
  // Optional `overlay` adds a light scrim so the title stays readable on photo backgrounds.
  const background = `${overlay ? 'linear-gradient(rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0.55)), ' : ''}url(${bgImg})`;
  return (

    <header id="page-top" className="blog-banner" style={{backgroundImage: background}}>
        <div className="container" id="blog">
            <div className="row blog-header text-left">
                <div className="col-sm-12"> 
                    <h4><Link to={process.env.PUBLIC_URL + "/"}> Home </Link> &gt; {title} </h4>
                    <h3>{title}</h3>
                </div>
            </div>
        </div>  
    </header> 
    
  );
};
 
export default PageHeader;

 